import { Currency } from 'fulfillment/types/DestinationWarehouseCost';

export function displayWithCurrency(value: string | number, currency: Currency): string {
  return `${currency.symbol}${value}`;
}

export function exchangedValue(value: number, exchangeRate = 1): string {
  return (value * exchangeRate).toFixed(2);
}
